import React, { Component } from 'react'
import { PageContainer } from 'smart-components'
import { userIsAuthenticatedRedir } from 'hocs/auth'

import './index.scss'

class QlikGrouchosaascharges extends Component {

    constructor(props) {
        super(props)
        this.mobileWidth = 0
        this.state = {
            width: window.innerWidth
        }
    }

    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }

    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    }

    render() {
        const url = "https://qlik.unifi.id/external-ticket-authentication/single/?appid=12672c6e-c5bd-454e-8462-88bb9f86ee07&sheet=b20526f0-9812-4d1f-9714-2657edc426b8&opt=currsel%2Cctxmenu&select=clearall"
        return (
            <PageContainer>
                <iframe src={url} />
            </PageContainer>
        )
    }
}

export default userIsAuthenticatedRedir(QlikGrouchosaascharges)



// WEBPACK FOOTER //
// ./src/pages/qlik-reports/groucho/saascharges/index.js